"use client";
import FavouriteStores from "./UI/FavouriteStores";
import ChannelCards from "./UI/ChannelCards";
import StatusAdMaxView from "./UI/StatusAdMaxView";
import ChannelViewMax from "./channel-view-max/ChannelViewMax";
import AdsStatusCards from "./UI/adsStatusCards";
import Navbar from "../../globalcomponents/navbar/Navbar";

const Advertisement = () => {
  return (
    <>
      <div className=" display-max">
        <Navbar />
        <div className=""style={{maxHeight:"100vh" }}>
          <div className=" card shadow container w-70 border border-radius-2xl mx-auto height-90">
            <div className=" d-flex row justify-content-center">
              <div className="col-lg-4 p-2 overflow-x-hidden overflow-y-scroll  border-end" style={{maxHeight:"100vh" , overflow:"hidden" , overflowY:"scroll"}}>
                <div
                
                  className="nav p-2 flex-column nav-pills"
                  id="v-pills-tab"
                  role="tablist"
                >
                  <div className=" d-flex justify-content-between align-items-center px-0">
                    <div className=" w-100">
                      <h4 className=" fw-bolder">Updates</h4>
                    </div>
                    <div className=" w-100"></div>
                  </div>
                  <div className=" input-group input-group-outline px-1">
                    <input
                      type="text"
                      className=" form-control fw-bolder"
                      placeholder=" Search.."
                    />
                    <span className=" input-group-text p-2 end-1">
                      <i className="bi bi-search fs-6"></i>
                    </span>
                  </div>
                 
                  <div className=" d-flex justify-content-between align-items-start px-1">
                    <div className=" w-100">
                      <h4>Ads Status</h4>
                    </div>
                  
                  </div>
                  <AdsStatusCards />
                  <div className=" d-flex justify-content-between align-items-center pt-3 px-1">
                    <div className=" w-100">
                      <h5>My Favourite Stores</h5>
                    </div>
                    <div className=" w-100 text-end">
                      <a href="/favourite-stores">
                        <button className=" btn btn-light btn-sm border-radius-40 text-black">
                          Explore
                        </button>
                      </a>
                    </div>
                  </div>
                  <FavouriteStores />
                  <div className=" d-flex justify-content-between align-items-center pt-5 px-1">
                    <div className=" w-100">
                      <h5>Recommended Stores</h5>
                    </div>
                    <div className=" w-100 text-end">
                      <a href="/recommended-stores">
                        <button className=" btn btn-light btn-sm border-radius-40 text-black">
                          Explore
                        </button>
                      </a>
                    </div>
                  </div>
                  {/* <RecommendedStores/> */}
                  <div className=" d-flex justify-content-between align-items-center pt-5 px-1">
                    <div className=" w-100">
                      <h5>Community Groups</h5>
                    </div>
                    <div className=" w-100 text-end">
                      <a href="/channel-view">
                        <button className=" btn btn-light btn-sm border-radius-40 text-black">
                          Explore
                        </button>
                      </a>
                    </div>
                  </div>
                  <ChannelCards />
                </div>
              </div>
              <div className="col-lg-8 border-radius-bottom-end-2xl border-radius-top-end-2xl position-sticky " style={{maxHeight:"100vh" , overflow:"hidden" , overflowY:"scroll"}}>
                <div className="tab-content" id="v-pills-tabContent">
                  
                    <div
                      className="tab-pane fade show active"
                      id="v-pills-ads-status-1"
                      role="tabpanel"
                      aria-labelledby="v-pills-ads-status-1-tab"
                    >
                      <StatusAdMaxView />
                    </div>
                
                  <div
                    className="tab-pane fade"
                    id="v-pills-fav-store-1"
                    role="tabpanel"
                    aria-labelledby="v-pills-fav-store-1-tab"
                  >
                    <ChannelViewMax />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" display-mini display-mob pb-7">
        <Navbar />
        <div className=" pt-6 px-1">
          <div className=" d-flex justify-content-between align-items-center px-1">
            <div className=" w-100">
              <h2 className=" fw-bolder">Updates</h2>
            </div>
            <div className=" w-100"></div>
          </div>
          <div className=" input-group input-group-outline px-1">
            <input
              type="text"
              className=" form-control fw-bolder"
              placeholder=" Search.."
            />
            <span className=" input-group-text p-2 end-1">
              <i className="bi bi-search fs-6"></i>
            </span>
          </div>
          <div className=" d-flex justify-content-between align-items-start mt-3 px-1">
            <div className=" w-100">
              <h4>Status</h4>
            </div>
            <div className=" w-100">
              <div className=" d-flex justify-content-end text-end gap-2">
                <div>
                  <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
                    <a href="/">
                      <i className="bi bi-camera-fill opacity-7 fs-5 text-black"></i>
                    </a>
                  </li>
                </div>
                <div>
                  <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
                    <a href="/">
                      <i className="bi bi-pencil-fill fs-6 opacity-7 text-black"></i>
                    </a>
                  </li>
                </div>
              </div>
            </div>
          </div>
          {/* <UpdateStatusCards  /> */}
          <div className=" d-flex justify-content-between align-items-center pt-3 px-1">
            <div className=" w-100">
              <h4>My Favourite Stores</h4>
            </div>
            <div className=" w-100 text-end">
              <a href="/favourite-stores">
                <button className=" btn btn-light btn-sm border-radius-40 text-black">
                  Explore
                </button>
              </a>
            </div>
          </div>
          <FavouriteStores />
          <div className=" d-flex justify-content-between align-items-center pt-5 px-1">
            <div className=" w-100">
              <h4>Recommended Stores</h4>
            </div>
            <div className=" w-100 text-end">
              <a href="/recommended-stores">
                <button className=" btn btn-light btn-sm border-radius-40 text-black">
                  Explore
                </button>
              </a>
            </div>
          </div>
          {/* <RecommendedStores /> */}
          <div className=" d-flex justify-content-between align-items-center pt-5 px-1">
            <div className=" w-100">
              <h4>Community Groups</h4>
            </div>
            <div className=" w-100 text-end">
              <a href="/channel-view">
                <button className=" btn btn-light btn-sm border-radius-40 text-black">
                  Explore
                </button>
              </a>
            </div>
          </div>
          <ChannelCards />
        </div>
      </div>
    </>
  );
};

export default Advertisement;
